import { render } from "./tempInquire.vue?vue&type=template&id=9e203830&scoped=true"
import script from "./tempInquire.vue?vue&type=script&lang=js"
export * from "./tempInquire.vue?vue&type=script&lang=js"

import "./tempInquire.vue?vue&type=style&index=0&id=9e203830&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e203830"]])

export default __exports__